<template>
  <div>
    <h2 v-if="titleText" class="text-center"><b>{{title}}</b></h2>
    <div class="text-center" ><!-- :style="streamButtons" -->
      <ul class="actions" style="display: inline-flex;">
        <li v-if="!channelIsEmpty(youtubeChannel)"><a :href="youtubeChannel" rel="noreferrer" target="_blank" style="background: #f00;" class="pulseButton button primary icon brands fa-youtube">Youtube Live</a></li>
        <li v-if="!channelIsEmpty(facebookChannel)"><a :href="facebookChannel" rel="noreferrer" target="_blank" style="background: #1877f2;" class="pulseButton button primary icon brands solid fa-facebook-f">Facebook</a></li>
      </ul>
    </div>
    <!--p v-if="expiredText" class="text-center" style="background: #FFFFFF85;"><i class="icon solid fa-clock fa-lg"></i> <b>Stream verpasst?</b><br/> Für 24 Stunden findet ihr den Film sowie das Interview <a target="_blank" rel="noreferrer" href="https://www.youtube.com/c/Sofareisen">HIER auf unserem YouTube Kanal</a></p-->
  </div>
</template>

<script>

export default {
  name: 'RTStreamLinks',
  props:{
    expiredText:{
      type:Boolean
    },
    titleText:{
      type:Boolean,
      default:true
    },
    stream:{
     type:Object
    },
  },
  data: function() {
    return {
      title:'Livestream & Chat auf',
      youtubeChannelUrl:"https://www.youtube.com/c/Sofareisen/live",
      facebookChannelUrl:""//https://www.facebook.com/sofareisen.org/live
    };
  },
  computed:{
    hasCustomYoutubeStreamVideo(){
      return (this.stream && !this._.isEmpty(this.stream.stream_url))
    },
    hasCustomYoutubeStream(){
      return (this.stream && !this._.isEmpty(this.stream.custom_youtube_channel))
    },
    hasCustomFacebookStream(){
      return (this.stream && !this._.isEmpty(this.stream.custom_facebook_channel))
    },
    hasCustomStreamUrl(){
      return this.hasCustomYoutubeStream || this.hasCustomFacebookStream || this.hasCustomYoutubeStreamVideo;
    },
    youtubeChannel(){
      return (this.hasCustomStreamUrl)?((this.hasCustomYoutubeStreamVideo)?this.stream.stream_url:this.stream.custom_youtube_channel):this.youtubeChannelUrl
    },
    facebookChannel(){
      return (this.hasCustomStreamUrl)?this.stream.custom_facebook_channel:this.facebookChannelUrl
    }
  },
  methods:{
    getTitle(){
      return this.title;
    },
    channelIsEmpty(channel){
      return this._.isEmpty(channel)
    }
  }
};
</script>

<style type='text/css'>
.pulseButton{
  -webkit-animation: pulsate 2s infinite ease-out;
  
}
@-webkit-keyframes pulsate {
	0% {-webkit-transform: scale(0.95, 0.95); }
  50% {-webkit-transform: scale(1, 1); }
	100% {-webkit-transform: scale(0.95, 0.95); }
}
</style>